import React, { Component } from 'react';
import './index..css';
import Navigation from '../Navigation';

class App extends Component {
  render() {
    return (
      <div className="App">
        <Navigation/>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App/index.js